import { T } from "../../styles/GlobalStyles";

const Spin = ({ c, s = 20 }) => (
  <div style={{ width: s, height: s, border: `2px solid ${T.border}`, borderTopColor: c || T.accent, borderRadius: "50%", animation: "spin .7s linear infinite", flexShrink: 0 }} />
);
export default Spin;
